import React, { FC } from 'react';

import { ILoadable } from './models';
import './Loadable.scss';

const Loadable: FC<ILoadable> = ({ isActive, children }) => (isActive ? <>{children}</> : null);

export default Loadable;
